import React from 'react';
import PropTypes from 'prop-types';

import {dispatch, connect} from 'utils/state_manager';

import {Box, Paper, Stack, Typography} from 'views/components';
import {Person} from 'views/icons';
import {Translate, translate} from 'views/module';

import buildBlakeCalendlyLink from '../../../utils/blakeCalendlyLink';

const BookCall = (props) => {
  const {user, clientData} = props;

  const calendlyLink = React.useMemo(() => {
    return buildBlakeCalendlyLink({
      user,
      clientData,
      eventTypeSlug: 'care-plan-call-with-daniel',
    });
  },
  [
    user?.userRn,
    user?.email,
    user?.firstName,
    user?.lastName,
    clientData?.clientDetail?.relationships?.[user?.userRn]?.contacts,
  ],
  );

  return (
    <Paper
      sx={{
        padding: '32px',
        borderRadius: '24px',
        boxShadow: 'none',
        backgroundColor: '#FFFFFF',
      }}
    >
      <Stack sx={{gap: '16px'}}>
        <Stack sx={{gap: '4px', mb: '16px'}}>
          <Typography sx={{fontSize: '24px', fontWeight: 300, color: '#2D2925', lineHeight: '128%', letterSpacing: '-2%', fontFamily: '"Spectral", serif'}}>
            <Translate expression={'careplanstep.BookCall.Title'} />
          </Typography>
          <Typography sx={{fontSize: '16px', fontWeight: 400, color: '#2D2925A3', lineHeight: '150%'}}>
            <Translate expression={'careplanstep.BookCall.Description'} />
          </Typography>
        </Stack>

        <Box sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: '16px'}}>
          <Box sx={{display: 'flex', alignItems: 'center', gap: '20px'}}>
            <Box
              sx={{
                width: '56px',
                height: '56px',
                borderRadius: '50%',
                backgroundColor: '#DA79551A',
                display: 'grid',
                placeItems: 'center',
              }}
            >
              <Person sx={{fontSize: '34px', color: '#DA7955'}} />
            </Box>
            <Stack sx={{gap: '2px'}}>
              <Typography sx={{fontSize: '20px', fontWeight: 300, lineHeight: '128%', color: '#2D2925', letterSpacing: '-2%', fontFamily: '"Spectral", serif'}}>
                <Translate expression={'careplanstep.BookCall.ContactName'} />
              </Typography>
              <Typography sx={{fontSize: '16px', fontWeight: 400, lineHeight: '150%', color: '#2D2925A3'}}>
                <Translate expression={'careplanstep.BookCall.ContactRole'} />
              </Typography>
            </Stack>
          </Box>
          <Box sx={{display: 'flex', alignItems: 'center', gap: '8px', flexShrink: 0}}>
            <Box sx={{width: '10px', height: '10px', borderRadius: '50%', backgroundColor: '#81C170'}} />
            <Typography sx={{fontSize: '16px', fontWeight: 400, lineHeight: '150%', color: '#81C170'}}>
              <Translate expression={'careplanstep.BookCall.Availability'} />
            </Typography>
          </Box>
        </Box>
        <Box
          sx={{
            borderRadius: '16px',
            border: '1px solid #E4DAD6',
            overflow: 'hidden',
            backgroundColor: '#FFFFFF',
            height: '910px',
          }}
        >
          <Box
            component='iframe'
            src={calendlyLink}
            title={translate('careplanstep.BookCall.Title')}
            loading='lazy'
            sx={{
              border: 0,
              width: '100%',
              height: '100%',
              display: 'block',
            }}
          >
          </Box>
        </Box>
      </Stack>
    </Paper>
  );
};

BookCall.propTypes = {
  user: PropTypes.object.isRequired,
  clientData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  user: state.user,
  clientData: state.clientData,
});

export default connect(mapStateToProps, dispatch)(React.memo(BookCall));
